<template>
  <div>
    <v-tabs
      v-model="keyType"
      color="black"
      slider-color="black"
      density="compact">
      <v-tab value="file">Файловий</v-tab>
      <v-tab value="media">Токен</v-tab>
      <v-tab value="cloud" :disabled="!allowCloud">Хмарний</v-tab>
    </v-tabs>
  </div>
</template>

<script lang="ts">
import { KeyType } from './types'
import { computed, inject, PropType } from 'vue'
import { dialogKey } from './injectionKeys'
import { useDisplay } from 'vuetify'

export default {
  name: 'KeyTypeSelect',
  emits: ['update:model-value'],
  props: {
    modelValue: {
      type: String as PropType<KeyType>,
    },
    allowCloud: {
      type: Boolean as PropType<boolean>,
    },
  },
  setup(props, { emit }) {
    const { mdAndUp } = useDisplay()
    const keyType = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        emit('update:model-value', val)
      },
    })

    const dialog = inject(dialogKey)!

    return { keyType, dialog, mdAndUp }
  },
}
</script>
